module.exports = __webpack_public_path__ + "static/media/tindog.99022e5f.jpg";